import { useQuery } from 'react-apollo';
import { gql } from 'apollo-boost';

import Payment from '../types/payment';

export const UNAPPLIED_INVOICES_QUERY = gql`
  query {
    unappliedPayments {
      id
      amountCents
      azAppliedAmountCents
      reason
      date
    }
  }
`;

const useUnappliedPayments = (): UseUnappliedPaymentsResponse => {
  const { loading, data, refetch } = useQuery<UnappliedPaymentsResponse>(UNAPPLIED_INVOICES_QUERY);

  const unappliedPayments = data?.unappliedPayments ?? [];
  return { unappliedPayments, loading, refetch };
};

export default useUnappliedPayments;

interface UseUnappliedPaymentsResponse {
  unappliedPayments: Payment[];
  loading: boolean;
  refetch: () => {};
}

interface UnappliedPaymentsResponse {
  unappliedPayments: Payment[];
}
